import poster from '@/static/assets/reviews/AmeliaPowell/video.jpg';
import subs from '@/static/assets/reviews/AmeliaPowell/subs.vtt';
import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';

export const AmeliaPowell: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Pet],
  reviewerName: 'Amelia',
  videoUrl: `${ASSETS_URL}/pet/AmeliaPowell_Pet.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
